package org.ssoft.server.common.msg

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
sealed interface GameReportContent {
    val id: Long
    val type: Int

    @Serializable
    data class Wheel(
        override val id: Long,
        override val type: Int,
        var idItem:Long,
        var idGroup:Long,
        var dt: LocalDateTime,
        val code:String
    ):GameReportContent
}